exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Radio__root,\n.DS__Radio__block,\n.DS__Radio__disabled,\n.DS__Radio__radio,\n.DS__Radio__text {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n.DS__Radio__root {\n  display: inline-flex;\n  align-items: flex-start;\n}\n\n.DS__Radio__block {\n  width: 100%;\n}\n\n.DS__Radio__disabled {\n  pointer-events: none;\n}\n\n.DS__Radio__radio {\n  margin-top: 2px;\n}\n\n.DS__Radio__position_left .DS__Radio__text {\n      margin-left: 6px;\n    }\n\n.DS__Radio__position_right {\n    flex-direction: row-reverse;\n  }\n\n.DS__Radio__position_right .DS__Radio__text {\n      margin-right: 6px;\n    }\n\n.DS__Radio__text {\n  cursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__Radio__root",
	"block": "DS__Radio__block",
	"disabled": "DS__Radio__disabled",
	"radio": "DS__Radio__radio",
	"text": "DS__Radio__text",
	"position_left": "DS__Radio__position_left",
	"position_right": "DS__Radio__position_right"
};